import { render, staticRenderFns } from "./magazine.vue?vue&type=template&id=79753a7e&scoped=true&"
import script from "./magazine.vue?vue&type=script&lang=js&"
export * from "./magazine.vue?vue&type=script&lang=js&"
import style0 from "./magazine.vue?vue&type=style&index=0&id=79753a7e&lang=sass&scoped=true&"
import style1 from "./magazine.vue?vue&type=style&index=1&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79753a7e",
  null
  
)

export default component.exports